import Swal from "sweetalert2";
import { t } from "i18next";
import { const_routes } from "../helpers/const_routes";
import { fetchToken } from "../helpers/fetch";
import { types } from "../types/types";
import { startLogout } from "./authActions";

const handleError = (body, dispatch) => {
  if (body.code === "bak-error-001") {
    Swal.fire(t("titles.error"), `${t("alerts.validation.bak-error-001")} - ${body.method}`, "error");
  }
  if (body.code === "bak-aut-tok-inv-001" || body.code === "bak-aut-tok-inv-002") {
    Swal.fire(t("titles.error"), t("api.token.invalid_petition"), "error");
    dispatch(startLogout());
  }
  if (body.ok === false && body.msg) {
    Swal.fire(t("titles.error"), body.msg, "error");
  }
};

export const startLoadingFlowChecklistDefs = (filters = {}) => {
  return async (dispatch) => {
    dispatch({ type: types.FLOW_CHECKLIST_SET_LOADING, payload: true });
    try {
      const query = new URLSearchParams(
        Object.entries(filters).filter(([, value]) => value !== '' && value !== null && value !== undefined)
      ).toString();
      const suffix = query ? `get?${query}` : 'get';
      const resp = await fetchToken(const_routes.SCHEMA, const_routes.VERSIONV1, const_routes.ROUTE_FLOW_CHECKLIST, suffix);
      const body = await resp.json();
      if (body.ok) {
        dispatch({ type: types.FLOW_CHECKLIST_SET_DEFS, payload: body.flowChecklistDefs || [] });
      } else {
        handleError(body, dispatch);
      }
    } finally {
      dispatch({ type: types.FLOW_CHECKLIST_SET_LOADING, payload: false });
    }
  };
};

export const startRegisterFlowChecklistDef = (data) => {
  return async (dispatch) => {
    const resp = await fetchToken(const_routes.SCHEMA, const_routes.VERSIONV1, const_routes.ROUTE_FLOW_CHECKLIST, 'add', data, 'POST');
    const body = await resp.json();
    if (body.ok) {
      dispatch(startLoadingFlowChecklistDefs());
      return body.flowChecklistDef;
    }
    handleError(body, dispatch);
    return null;
  };
};

export const startUpdateFlowChecklistDef = (id, data) => {
  return async (dispatch) => {
    const resp = await fetchToken(const_routes.SCHEMA, const_routes.VERSIONV1, const_routes.ROUTE_FLOW_CHECKLIST, `update/${id}`, data, 'PUT');
    const body = await resp.json();
    if (body.ok) {
      dispatch(startLoadingFlowChecklistDefs());
      return body.flowChecklistDef;
    }
    handleError(body, dispatch);
    return null;
  };
};

export const startDeleteFlowChecklistDef = (id) => {
  return async (dispatch) => {
    const resp = await fetchToken(const_routes.SCHEMA, const_routes.VERSIONV1, const_routes.ROUTE_FLOW_CHECKLIST, `delete/${id}`, {}, 'DELETE');
    const body = await resp.json();
    if (body.ok) {
      dispatch(startLoadingFlowChecklistDefs());
      return true;
    }
    handleError(body, dispatch);
    return false;
  };
};

export const startLoadingRecordChecklist = (moduleId, referenceId, query = {}) => {
  return async (dispatch) => {
    const params = new URLSearchParams(query).toString();
    const suffix = `getByRecord/${moduleId}/${referenceId}${params ? `?${params}` : ''}`;
    const resp = await fetchToken(const_routes.SCHEMA, const_routes.VERSIONV1, const_routes.ROUTE_FLOW_CHECKLIST, suffix);
    const body = await resp.json();
    if (body.ok) {
      dispatch({ type: types.FLOW_CHECKLIST_SET_RECORD, payload: body.checklist || {} });
    } else {
      handleError(body, dispatch);
    }
  };
};

export const startToggleChecklistItem = (data) => {
  return async (dispatch) => {
    const payload = { ...data };
    if (Array.isArray(data?.mass_targets) && data.mass_targets.length) {
      payload.mass_targets = data.mass_targets.map((id) => Number(id)).filter((id) => Number.isFinite(id));
    }
    const resp = await fetchToken(const_routes.SCHEMA, const_routes.VERSIONV1, const_routes.ROUTE_FLOW_CHECKLIST, 'toggle', payload, 'POST');
    const body = await resp.json();
    if (body.ok) {
      dispatch({ type: types.FLOW_CHECKLIST_SET_RECORD, payload: body.checklist || {} });
      return body.checklist;
    }
    handleError(body, dispatch);
    return null;
  };
};

export const startSelectAllChecklist = (data) => {
  return async (dispatch) => {
    const payload = { ...data };
    if (Array.isArray(data?.mass_targets) && data.mass_targets.length) {
      payload.mass_targets = data.mass_targets.map((id) => Number(id)).filter((id) => Number.isFinite(id));
    }
    const resp = await fetchToken(const_routes.SCHEMA, const_routes.VERSIONV1, const_routes.ROUTE_FLOW_CHECKLIST, 'selectAll', payload, 'POST');
    const body = await resp.json();
    if (body.ok) {
      dispatch({ type: types.FLOW_CHECKLIST_SET_RECORD, payload: body.checklist || {} });
      return body.checklist;
    }
    handleError(body, dispatch);
    return null;
  };
};
